module.exports = __webpack_public_path__ + "static/media/qixi_jiangli_dialog.baf2a396.png";